<template>
    <div>
        <!--  BEGIN NAVBAR  -->
        <Header v-if="!layoutState.isAuth"></Header>
        <!--  END NAVBAR  -->

        <!--  BEGIN MAIN CONTAINER  -->
        <div class="main-container" id="container" :class="containerClasses">
            <!--  BEGIN OVERLAY  -->
            <div v-if="!layoutState.isAuth" class="overlay" :class="{ show: !layoutState.showSidebar }" @click="toggleSidebar"></div>
            <div v-if="!layoutState.isAuth" class="search-overlay" :class="{ show: layoutState.showSearch }" @click="toggleSearch"></div>
            <!-- END OVERLAY -->

            <!--  BEGIN SIDEBAR  -->
            <Sidebar v-if="!layoutState.isAuth"></Sidebar>
            <!--  END SIDEBAR  -->

            <!--  BEGIN CONTENT AREA  -->
            <div id="content" class="main-content" :class="layoutState.isAuth ? 'auth-layout' : ''">
                <router-view />
            </div>
            <!--  END CONTENT AREA  -->

            <!-- BEGIN APP SETTING LAUNCHER -->
            <app-settings v-if="!layoutState.isAuth" />
            <!-- END APP SETTING LAUNCHER -->

            <!-- BEGIN NOTIFICATION TOASTS -->
            <NotificationToast />
            <!-- END NOTIFICATION TOASTS -->

            <LegalGraceBanner />
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { useLayout } from '@/composables/useLayout';
    import Header from "../components/layout/header.vue";
    import Sidebar from "../components/layout/sidebar.vue";
    import appSettings from "../components/app-settings.vue";
    import NotificationToast from "../components/notifications/NotificationToast.vue";
    import LegalGraceBanner from "../components/legal/LegalGraceBanner.vue";

    const { layoutState, toggleSidebar, toggleSearch } = useLayout();

    const containerClasses = computed(() => [
        !layoutState.value.showSidebar ? 'sidebar-closed sbar-open' : '',
        layoutState.value.sidebarSkipTransition ? 'sidebar-instant' : '',
        layoutState.value.menuStyle === 'collapsible-vertical' ? 'collapsible-vertical-mobile' : '',
        layoutState.value.isAuth ? 'main-container-auth' : ''
    ]);

    
</script>
